export enum portColors {
  Transfer = '#187bde',
  Instrumentation = '#ad5f2e',
  Sampling = '#6a2fad'
}
